import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MarketplaceComponent } from './marketplace/marketplace.component';
import { AsamcoRouterGuard, CustomRouteConfig } from '@asamco/base';
import { LinkEditPageComponent } from './link/link-edit-page/link-edit-page.component';
import { UsermanagementComponent } from './usermanagement/usermanagement.component';
import { FunctionappmanagementComponent } from './functionappmanagement/functionappmanagement.component';
import { IntegrationTesterComponent } from './integration-tester/integration-tester.component';
import { ContactComponent } from './contact/contact.component';
import { FunctionappversioningComponent } from './functionappversioning/functionappversioning.component';
import { AdminLinkOverviewComponent } from './admin-link-overview/admin-link-overview.component';
import { ApplicationLogsOverviewComponent } from './application-logs-overview/application-logs-overview.component';
import { AdminToolingOverviewComponent } from './admin-tooling/admin-tooling-overview/admin-tooling-overview.component';
import { ApplicationEditComponent } from './admin-tooling/tools/application/application-edit/application-edit.component';
import { FunctionAppsComponent } from './function-apps/function-apps.component';
import { DurableFunctionAppManagementComponent } from './durable-function-app-management/durable-function-app-management.component';

export const routes: CustomRouteConfig = [
	{
		path: 'dashboard',
		component: DashboardComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'marketplace',
		component: MarketplaceComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'companyusermanagement',
		component: UsermanagementComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'companyusermanagement/:tab',
		component: UsermanagementComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'functionappmanagement',
		component: FunctionappmanagementComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'durable-function-app-management',
		component: DurableFunctionAppManagementComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'functionappversioning',
		component: FunctionappversioningComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'function-apps',
		component: FunctionAppsComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'adminlinkoverview',
		component: AdminLinkOverviewComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'admin-tooling-overview/:tab',
		component: AdminToolingOverviewComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'link/:id',
		component: LinkEditPageComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'application/:id',
		component: ApplicationEditComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'integrationtester',
		component: IntegrationTesterComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'contact',
		component: ContactComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{ path: '', redirectTo: 'dashboard', pathMatch: 'full' },
];
